<template>
  <div id="container" class="d-aligncnter">
    <i :class="getCurrIcon()"></i>
    <div style="margin-left: 6px">{{ gaodeWeather.weather }}</div>
    <div style="margin-left: 6px" v-if="!!gaodeWeather.temperature">{{ gaodeWeather.temperature }}°C</div>
  </div>
</template>
<script></script>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'

// import axios from 'axios'
export default {
  data() {
    return {
      gaodeWeather: {},
      icons: {
        晴: 'qi-100',
        多云: 'qi-101',
        少云: 'qi-101',
        晴间多云: 'qi-101',
        阴: 'qi-104',
        阵雨: 'qi-300',
        雷阵雨: 'qi-302',
        雷阵雨并伴有冰雹: 'qi-304',
        雨: 'qi-305',
        小雨: 'qi-305',
        中雨: 'qi-306',
        大雨: 'qi-307',
        暴雨: 'qi-310',
        大暴雨: 'qi-311',
        特大暴雨: 'qi-312',
        雪: 'qi-400',
        阵雪: 'qi-400',
        小雪: 'qi-400',
        中雪: 'qi-401',
        大雪: 'qi-402',
        暴雪: 'qi-403',
        '小雪-中雪': 'qi-401',
        '中雪-大雪': 'qi-402',
        '大雪-暴雪': 'qi-403',
        有风: 'qi-2208',
        平静: 'qi-2208',
        微风: 'qi-2208',
        和风: 'qi-2208',
        大风: 'qi-2208',
        疾风: 'qi-2210',
        烈风: 'qi-2210',
        风暴: 'qi-2210',
      },
      city: '',
      MyAMap: {},
    }
  },
  computed: {
    getCurrIcon() {
      return function () {
        return this.icons[this.gaodeWeather.weather]
      }
    },
  },
  mounted() {
    console.log('mounted')
    // this.Tmap()
    this.initWeather()
  },
  methods: {
    // Tmap() {
    //   const that = this
    //   window.addEventListener(
    //     'message',
    //     function (event) {
    //       var loc = event.data
    //       console.log(loc) // 显示你当前位置
    //       if (loc) {
    //         that.city = loc.city
    //         that.initWeather()
    //         window.removeEventListener('message')
    //       }
    //     },
    //     false
    //   )
    // },
    initWeather() {
      window._AMapSecurityConfig = {
        securityJsCode: '253310fae09d0b650e010f5e68f0525d',
      }
      AMapLoader.load({
        key: 'b04ee49e200a5a0a38cd37114ef8c9d5', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Scale'], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          // this.map = new AMap.Map('container', {
          //   // 设置地图容器id
          //   viewMode: '2D', // 是否为3D地图模式
          //   zoom: 11, // 初始化地图级别
          //   //   center: [116.397428, 39.90923], // 初始化地图中心点位置
          // })
          this.MyAMap = AMap
          const that = this

          AMap.plugin('AMap.CitySearch', function () {
            var citySearch = new AMap.CitySearch()
            citySearch.getLocalCity(function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                console.log(result)
                that.city = result.city
                that.getWeather(result.city)
              }
            })
          })
          //   AMap.plugin('AMap.Weather', function () {
          //     var weather = new AMap.Weather()
          //     weather.getLive(that.city, function (err, data) {
          //       that.gaodeWeather = { ...data }
          //       if (!err) {
          //         //赋值天气
          //         that.gaodeWeather = data
          //       }
          //     })
          //   })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getWeather() {
      const that = this
      this.MyAMap.plugin('AMap.Weather', function () {
        var weather = new AMap.Weather()
        weather.getLive(that.city, function (err, data) {
          that.gaodeWeather = { ...data }
          if (!err) {
            //赋值天气
            that.gaodeWeather = data
          }
        })
      })
      //   fetch(`https://restapi.amap.com/v3/weather/weatherInfo?city=${city}&key=eefd36557b0250duu19d243aea0f62d499`)
      //     .then((res) => {
      //       console.log('data: ', res)
      //       return res.json
      //     })
      //     .then((data) => {
      //       const { lives } = data
      //       console.log('data: ', lives)

      //       this.gaodeWeather = lives.weather
      //     })
    },
  },
}
</script>
